import { createFileRoute, Navigate } from "@tanstack/react-router";
import { TeamsOverviewPage } from "@/pages/teams-overview/ui/teams-overview-page";
import { useIsOwnerOrAdmin } from "@/entities/user/hooks/use-is-owner-or-admin";

const TeamsOverviewRoute = () => {
  const { isOwnerOrAdmin } = useIsOwnerOrAdmin();

  // Redirect non-admin users
  if (!isOwnerOrAdmin) {
    return <Navigate to="/" replace />;
  }

  return <TeamsOverviewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/teams",
)({
  component: TeamsOverviewRoute,
});
